import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "../src/i18n/config";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import lightThemeOptions from "./theme/lightThemeOptions";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material";
import {store} from "./store";
import './styles'
import { GoogleOAuthProvider } from "@react-oauth/google";
let lightTheme = createTheme(lightThemeOptions);
lightTheme = responsiveFontSizes(lightTheme);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={lightTheme}>
        <Router>
          <GoogleOAuthProvider clientId={"894661361392-pi86vu1fr98pbo074j35q85gap68ch3j.apps.googleusercontent.com"}>
          <App />
          </GoogleOAuthProvider>
        </Router>
      </ThemeProvider>
    </Provider>
  // </React.StrictMode>
);
